import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams, Link, Navigate } from "react-router-dom";

import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableFooter,
  TablePagination,
} from "@mui/material";

import { format } from "date-fns";

import * as actions from "../../redux/actions/index";
import PageLoading from "../../components/PageLoading/PageLoading.component";
import { TablePaginationActions } from "../../components/TablePaginationActions/TablePaginationActions.component";
import { FIRST_PAGE, PAGE_SIZE_OPTIONS } from "../../utils/paginationConstants";

const CustomerView = () => {
  let { id } = useParams();
  const dispatch = useDispatch();
  const cmsAuth = useSelector((state) => state.cmsAuthenticator.cmsAuth || "");
  const loading = useSelector(
    (state) => state.cmsTransactions.fetchTransactionsLoading
  );
  const transactions = useSelector(
    (state) => state.cmsTransactions.transactions
  );
  const total = useSelector((state) => state.cmsTransactions.total || 0);
  const [sortedTransactions, setSortedTransactions] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(PAGE_SIZE_OPTIONS[0]);
  const [page, setPage] = useState(FIRST_PAGE);
  const role = cmsAuth.role.toLowerCase().replace("_", "");

  useEffect(() => {
    dispatch(actions.onFetchCustomer(id));
    dispatch(
      actions.onFetchTransactionsById(id, FIRST_PAGE, rowsPerPage, role)
    );
  }, [dispatch, id]);

  useEffect(() => {
    if (!!transactions) {
      const sortedTransactions = transactions.sort((a, b) => {
        return b.id - a.id;
      });
      setSortedTransactions(sortedTransactions);
    }
  }, [transactions]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    dispatch(actions.onFetchTransactionsById(id, newPage, rowsPerPage, role));
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(FIRST_PAGE);
    dispatch(
      actions.onFetchTransactionsById(
        id,
        FIRST_PAGE,
        parseInt(event.target.value),
        role
      )
    );
  };

  const adminRestrict =
    cmsAuth.role === "ADMIN" || cmsAuth.role === "COLLABORATOR_ADMIN" ? (
      <Navigate to="/dashboard" />
    ) : null;
  const agentRestrict =
    cmsAuth.role === "AGENT" ? <Navigate to="/transactions" /> : null;

  return (
    <div className="CustomerView">
      {adminRestrict}
      {agentRestrict}
      <PageLoading loading={loading} />
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Receipt #</TableCell>
              <TableCell>Store</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Transaction Date</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedTransactions.map((transaction, i) => {
              const transactionDateFormatted = transaction.created_at
                ? format(new Date(transaction.created_at), "MM/dd/yyyy HH:mm")
                : null;
              return (
                <TableRow key={i} hover>
                  <TableCell
                    component={Link}
                    to={`/transactions/${transaction.id}`}
                  >
                    {transaction.id}
                  </TableCell>
                  <TableCell
                    component={Link}
                    to={`/transactions/${transaction.id}`}
                  >
                    {transaction.receipt_number}
                  </TableCell>
                  <TableCell
                    component={Link}
                    to={`/transactions/${transaction.id}`}
                  >
                    {transaction.receipt_merchant == "null"
                      ? ""
                      : transaction.receipt_merchant}
                  </TableCell>
                  <TableCell
                    component={Link}
                    to={`/transactions/${transaction.id}`}
                    id="status"
                    className={transaction.status.toLowerCase()}
                  >
                    {transaction.status}
                  </TableCell>
                  <TableCell
                    component={Link}
                    to={`/transactions/${transaction.id}`}
                  >
                    {transactionDateFormatted}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={PAGE_SIZE_OPTIONS}
                colSpan={14}
                count={total}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  inputProps: {
                    "aria-label": "rows per page",
                  },
                  native: true,
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
    </div>
  );
};

export default CustomerView;
